// extracted by mini-css-extract-plugin
export default {"element":"FlashHighlight_element__2FegP","flash":"FlashHighlight_flash__kf2od"};